<template>
  <fragment>
    <v-row>
      <v-col cols="6">
        <v-btn
          width="100%"
          class="rounded-lg"
          color="white"
          @click="openDescriptionModal"
          hide-details
        >
          <v-icon left v-if="descriptionIsNotEmpty" color="green"
            >mdi-text-box-check-outline</v-icon
          >
          <v-icon left v-else>mdi-text-box-remove-outline</v-icon>
          Insira aqui a descrição
        </v-btn>
      </v-col>
      <v-col cols="6">
        <BaseSelect
          label="Status"
          required
          placeholder="Selecione o status do produto"
          item-text="value"
          item-value="key"
          :items="$produtos_gerenciar.status_produtos"
          :rules="[rules.required]"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.status"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <BaseSelect
          label="Categoria"
          required
          placeholder="Selecione uma categoria"
          item-text="descricao"
          item-value="idcategoria"
          :items="$produtos_gerenciar.categorias_produtos"
          :rules="[rules.required]"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.categoria"
        />
      </v-col>
      <v-col>
        <BaseMoneyField
          required
          label="Preço"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.preco"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <BaseSelect
          label="Tag"
          item-text="key"
          item-value="value"
          placeholder="Selecione as tags"
          :items="tags"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.tags"
        />
      </v-col>
      <v-col cols="6">
        <v-checkbox
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.destaque"
          label="Produto em destaque"
          class="rounded-lg pa-2 mt-0"
          style="border: 1px solid rgb(0 0 0 / 42%)"
          active-class="active-class"
          hide-details
        >
        </v-checkbox>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-checkbox
          v-model="
            $produtos_gerenciar.cadastro.dados_cadastrais.limitarIngressos
          "
          label="Limitar Ingressos por Consumidor"
          class="rounded-lg pa-2 mt-0"
          style="border: 1px solid rgb(0 0 0 / 42%)"
          active-class="active-class"
          hide-details
        >
        </v-checkbox>
      </v-col>
      <v-col cols="6">
        <BaseTextField
          hide-details
          label="Limitar ingressos por consumidor"
          placeholder="Ex: 5"
          type="number"
          min="1"
          v-model="
            $produtos_gerenciar.cadastro.dados_cadastrais.limite_venda_cpf
          "
          :disabled="!limitedTickets"
        />
      </v-col>
    </v-row>
    <DescriptionProduct />
  </fragment>
</template>
<script>
import mixins from "@/mixins";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseMoneyField from "@/components/forms/BaseMoneyField.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import DescriptionProduct from "@/components/produtos/gerenciar/DescriptionProduct.vue";

const { formRules, products } = mixins;

export default {
  name: "RechargeProduct",
  mixins: [formRules, products],
  data: () => ({
    stockExplain:
      "ℹ️ Caso seu produto contenha mais de uma opção, o estoque será somado e apresentado aqui.",
  }),
  components: {
    BaseSelect,
    BaseMoneyField,
    BaseTextField,
    DescriptionProduct,
  },
  methods: {
    openDescriptionModal() {
      this.$produtos_gerenciar.descriptionModal = true;
    },
  },
  computed: {
    descriptionIsNotEmpty() {
      return (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.descritivo !== ""
      );
    },
    limitedTickets() {
      return this.$produtos_gerenciar.cadastro.dados_cadastrais
        .limitarIngressos;
    },
    manageStock() {
      return (
        this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos
          .length === 0 &&
        this.$produtos_gerenciar.cadastro.dados_cadastrais.gerenciar_estoque ===
          1
      );
    },
  },
};
</script>
<style>
.active-class {
  background-color: #e6f7ff !important;
  border-color: #91d5ff !important;
  color: #1890ff !important;
}
</style>
